export default __webpack_public_path__ + "static/media/spatial-repetition-stage-3-paused.bef3a82a.png";